/**
 * 创建应用实体组件
 * zxw
 * 创建时间 2026-02-03
 */

import CNF from '../../incs/Config';
import { AddRequestHeaders } from '../../incs/FunHelper';
import {
    WorkFlowIcon,
    // AgentIcon,
} from '../../incs/Icons';

import { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    Flex,
    Modal,
    Space,
    Typography,
    Card,
    Radio,
    Input,
    Avatar,
    message,
} from 'antd';

const { Paragraph, Text, Link, Title } = Typography;
const { TextArea } = Input;

const MODULENAME_URL = '/app/infos';

const AppCreateEntity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [appType, setAppType] = useState(CNF.WORKFLOW);       // 应用类型
    const [appName, setAppName] = useState(null);               // 应用名称
    const [appDescription, setAppDescription] = useState(null); // 应用描述


    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const cancel = () => {
        setOpen(false);
    }

    const ok = () => {
        //  参数校验
        if (appName === '') {
            messageApi.error('词语不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1,)}`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'app_type': appType,
                'app_name': appName,
                'app_icon': CNF.appIcon,
                'app_description': appDescription,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    if (props.setRefresh) props.setRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }


    return <ConfigProvider theme={{
        token: {
            colorPrimary: global.THEMECOLOR,
        },
    }}>
        {contextHolder}
        <Modal
            title={<span style={{ color: CNF.baseTextColor }}>创建应用</span>}
            mask={{ blur: false }}
            width={960}
            open={open}
            okText='立即创建'
            onOk={ok}
            onCancel={cancel}
            okButtonProps={{ loading }}
            style={{
                top: CNF.menuHeight,
            }}
            styles={{
                container: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                header: {
                    paddingLeft: 20,
                    paddingBottom: 14,
                    borderBottom: `1px solid ${CNF.baseBorderSolidColor}`,
                    marginBottom: 0,
                },
                footer: {
                    borderTop: `1px solid ${CNF.baseBorderSolidColor}`,
                    marginTop: 0,
                    paddingRight: 20,
                    paddingTop: 20,
                }
            }}
        >
            <Flex>
                {/* --start-- 左侧部分 */}
                <div style={{
                    width: 240,
                    height: 594,
                    borderRight: `1px solid ${CNF.baseBorderSolidColor}`,
                    padding: 20,
                }}>
                    <Space orientation='vertical' size='middle'>
                        <Text style={{ color: CNF.basePlaceholderColor, fontSize: CNF.fontSizeSM, }}>低代码</Text>
                        <Link onClick={() => {
                            setAppType(CNF.WORKFLOW);
                        }}>
                            <Card
                                hoverable
                                style={{ width: 240, }}
                                styles={{
                                    root: {
                                        boxShadow: appType === CNF.WORKFLOW ? '0 2px 8px rgba(0,0,0,0.1)' : '',
                                        border: `1px solid ${appType === CNF.WORKFLOW ? global.THEMECOLOR : CNF.baseBorderSolidColor}`,
                                    },
                                    body: {
                                        padding: 16,
                                    },
                                }}
                            >
                                <Flex>
                                    <div style={{ width: '80%' }}>
                                        <Space>
                                            <WorkFlowIcon style={{ color: global.THEMECOLOR, fontSize: 18 }} />
                                            <Text style={{ color: CNF.baseTextColor }}><strong>{CNF.WORKFLOW}</strong></Text>
                                        </Space>
                                    </div>
                                    <div style={{ width: '20%', display: 'flex', justifyContent: 'flex-end', }}>
                                        <Space>
                                            <Radio checked={appType === CNF.WORKFLOW} />
                                        </Space>
                                    </div>
                                </Flex>
                                <Paragraph style={{ color: CNF.basePlaceholderColor, marginTop: 10, marginBottom: 0, fontSize: CNF.fontSizeSM }}>通过画布自定义编排工作流</Paragraph>
                            </Card>
                        </Link>
                        {/* <Link onClick={() => {
                            setAppType(CNF.AGENT);
                        }}>
                            <Card
                                hoverable
                                style={{ width: 240, }}
                                styles={{
                                    root: {
                                        boxShadow: appType === CNF.AGENT ? '0 2px 8px rgba(0,0,0,0.1)' : '',
                                        border: `1px solid ${appType === CNF.AGENT ? global.THEMECOLOR : CNF.baseBorderSolidColor}`,
                                    },
                                    body: {
                                        padding: 16,
                                    },
                                }}
                            >
                                <Flex>
                                    <div style={{ width: '80%' }}>
                                        <Space>
                                            <Text style={{ color: global.THEMECOLOR, }}><AgentIcon /></Text>
                                            <Text style={{ color: CNF.baseTextColor }}><strong>{CNF.AGENT}</strong></Text>
                                        </Space>
                                    </div>
                                    <div style={{ width: '20%', display: 'flex', justifyContent: 'flex-end', }}>
                                        <Space>
                                            <Radio checked={appType === CNF.AGENT} />
                                        </Space>
                                    </div>
                                </Flex>
                                <Paragraph style={{ color: CNF.basePlaceholderColor, marginTop: 10, marginBottom: 0, fontSize: CNF.fontSizeSM }}>构建智能体应用，连接知识、插件等</Paragraph>
                            </Card>
                        </Link> */}
                    </Space>
                </div>
                {/* --end-- 左侧部分 */}

                {/* --start-- 右侧部分 */}
                <div style={{ width: 638 }}>
                    {/* 广告部分 */}
                    <div style={{
                        height: 110,
                        width: '100%',
                        background: CNF.baseBgColor,
                    }}>
                        <Flex>
                            <div style={{ width: '60%', padding: 20, }}>
                                <Space orientation='vertical' size='middle'>
                                    <Title level={5} style={{ margin: 0, color: CNF.baseTextColor }}>创建工作流应用</Title>
                                    <Paragraph style={{ fontSize: CNF.fontSizeSM, color: CNF.basePlaceholderColor }}>通过画布自定义编排工作流，实现复杂的业务逻辑处理，支持多种节点类型和条件分支，适用于自动化任务处理场景。</Paragraph>
                                </Space>
                            </div>
                            <div style={{ width: '40%' }}>
                                <div style={{
                                    backgroundImage: `url(https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/xiny/09ba66695e361e2dde3c82919445bcc7-app-create-workflow-2-tps-984-440.png)`,
                                    backgroundSize: 'cover',
                                    height: 110,
                                }}></div>
                            </div>
                        </Flex>
                    </div>

                    {/* 内容部分 */}
                    <div style={{ padding: 20, width: '100%', }}>
                        <Space orientation='vertical' size='middle' style={{ width: '100%', }}>
                            <div>
                                <Text style={{ color: CNF.baseTextColor }}>应用名称<Text type='danger'>*</Text></Text>
                                <Input
                                    style={{ width: '100%', color: CNF.baseTextColor }}
                                    placeholder='请输入应用名称'
                                    count={{
                                        show: true,
                                        max: 50,
                                    }}
                                    status={appName?.length > 50 || appName === '' ? 'error' : ''}
                                    value={appName}
                                    onChange={(e) => setAppName(e.target.value)}
                                />
                                {
                                    appName === '' ? <Text type='danger'>请输入应用名称</Text> : ''
                                }
                            </div>
                            <div>
                                <Text style={{ color: CNF.baseTextColor }}>应用描述</Text>
                                <TextArea
                                    style={{ width: '100%', color: CNF.baseTextColor }}
                                    placeholder='请输入应用描述'
                                    value={appDescription}
                                    onChange={(e) => setAppDescription(e.target.value)}
                                />
                            </div>
                            <div>
                                <Text style={{ color: CNF.baseTextColor }}>应用图像</Text>
                                <div>
                                    <Avatar
                                        shape='square'
                                        size={48}
                                        style={{
                                            border: `1px solid ${CNF.baseBorderSolidColor}`,
                                            fontSize: 32,
                                            backgroundColor: CNF.baseBgColor,
                                            color: global.THEMECOLOR,
                                        }}
                                    >
                                        <WorkFlowIcon />
                                    </Avatar>
                                </div>
                            </div>
                        </Space>
                    </div>
                </div>
                {/* --end-- 右侧部分 */}
            </Flex>
        </Modal >
    </ConfigProvider>
}

export default AppCreateEntity